import { getOnPlatformReport } from 'reporting-data/public/transform-completed-activities';
import PlatformReportResolver from '../../PlatformReport/PlatformReportResolver';
import { MigratedReportLoadWrapper } from '../../PlatformReport/MigratedReportLoadWrapper';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const CompletedActivities = props => {
  const {
    report
  } = props;
  const platformReport = getCustomWidgetType(report) === CUSTOM_WIDGET_TYPES.COMPLETED_ACTIVITIES ? getOnPlatformReport(report) : report;
  return /*#__PURE__*/_jsx(PlatformReportResolver, Object.assign({}, props, {
    report: platformReport,
    lazyReportResolve: false
  }));
};
const withMigratedReport = Component => {
  return props => {
    return /*#__PURE__*/_jsx(MigratedReportLoadWrapper, {
      ChildComponent: Component,
      report: props.report,
      props: props
    });
  };
};
export const Component = withMigratedReport(CompletedActivities);